import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=1e4b003f&scoped=true&"
import script from "./UserMenu.vue?vue&type=script&lang=js&"
export * from "./UserMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=1e4b003f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b003f",
  null
  
)

export default component.exports